import axios from "../axios";
import { normalizeHseRiskCategory, normalizeHseRiskCategories } from "../../components/dashboard/hse/hseCompanySettingsUtils";

const PATH = "/hse/risk-categories";

function unwrap(response) {
  return response.data?.data || response.data;
}

function raiseApiError(error) {
  const errors = error?.response?.data?.errors;
  const message = Array.isArray(errors)
    ? errors.join(", ")
    : error?.response?.data?.message || error?.message || "error";
  const next = new Error(message);
  next.response = error?.response;
  throw next;
}

export async function fetchHseRiskCategories() {
  try {
    const response = await axios.get(PATH);
    return {
      data: normalizeHseRiskCategories(response.data?.data || []),
      meta: response.data?.meta || {},
    };
  } catch (error) {
    raiseApiError(error);
  }
}

export async function createHseRiskCategory(payload) {
  try {
    const response = await axios.post(PATH, { risk_category: payload });
    return normalizeHseRiskCategory(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function updateHseRiskCategory(id, payload) {
  try {
    const response = await axios.put(`${PATH}/${id}`, { risk_category: payload });
    return normalizeHseRiskCategory(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function deleteHseRiskCategory(id) {
  try {
    const response = await axios.delete(`${PATH}/${id}`);
    return response.data;
  } catch (error) {
    raiseApiError(error);
  }
}
